import { render, staticRenderFns } from "./game-list.vue?vue&type=template&id=3a1cfb46&scoped=true&"
import script from "./game-list.vue?vue&type=script&lang=js&"
export * from "./game-list.vue?vue&type=script&lang=js&"
import style0 from "./game-list.vue?vue&type=style&index=0&id=3a1cfb46&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1cfb46",
  null
  
)

component.options.__file = "game-list.vue"
export default component.exports